import h from 'react-hyperscript';

import '../Css/AnimateCss/AnimateCss.css';
import './App.css';

import Nav from '../Nav';
import { Services, Team, TalkBusiness, Contact } from '../Sections';

import '../Css/ResponsiveCss/ResponsiveCss.css';

export default () => h('div', [h(Nav), h(Services), h(Team), h(TalkBusiness), h(Contact)]);



// WEBPACK FOOTER //
// ./src/components/App/App.js